/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBarsXyVIcon16Light } from './DataChartBarsXyVIcon16Light';
import { DataChartBarsXyVIcon16Regular } from './DataChartBarsXyVIcon16Regular';
import { DataChartBarsXyVIcon16Solid } from './DataChartBarsXyVIcon16Solid';
import { DataChartBarsXyVIcon20Light } from './DataChartBarsXyVIcon20Light';
import { DataChartBarsXyVIcon20Regular } from './DataChartBarsXyVIcon20Regular';
import { DataChartBarsXyVIcon20Solid } from './DataChartBarsXyVIcon20Solid';
import { DataChartBarsXyVIcon24Regular } from './DataChartBarsXyVIcon24Regular';
import { DataChartBarsXyVIcon24Solid } from './DataChartBarsXyVIcon24Solid';
import { DataChartBarsXyVIcon32Regular } from './DataChartBarsXyVIcon32Regular';
import { DataChartBarsXyVIcon64Regular } from './DataChartBarsXyVIcon64Regular';
var sizes = {
    16: {
        light: DataChartBarsXyVIcon16Light,
        regular: DataChartBarsXyVIcon16Regular,
        solid: DataChartBarsXyVIcon16Solid,
    },
    20: {
        light: DataChartBarsXyVIcon20Light,
        regular: DataChartBarsXyVIcon20Regular,
        solid: DataChartBarsXyVIcon20Solid,
    },
    24: {
        regular: DataChartBarsXyVIcon24Regular,
        solid: DataChartBarsXyVIcon24Solid,
    },
    32: {
        regular: DataChartBarsXyVIcon32Regular,
    },
    64: {
        regular: DataChartBarsXyVIcon64Regular,
    },
};
export var DataChartBarsXyVIcon = forwardRef('DataChartBarsXyVIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
